import { render, staticRenderFns } from "./EditPoll.vue?vue&type=template&id=489e5cb5&"
import script from "./EditPoll.vue?vue&type=script&lang=ts&"
export * from "./EditPoll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports